function flatten(node, depth, acc) {
  if (!node) return;
  acc.push({ ...node, depth });
  const kids = node.children || [];
  for (let i = 0; i < kids.length; i++) {
    flatten(kids[i], depth + 1, acc);
  }
}

export default function ReferralTree({ root }) {
  if (!root) return null;
  const rows = [];
  flatten(root, 0, rows);
  return (
    <div>
      {rows.map((n) => {
        const dot = n.depth === 0 ? "bg-pink-500" : "bg-slate-500";
        const style = { paddingLeft: `${n.depth * 20}px` };
        const border = n.depth > 0 ? "border-l border-white/10" : "";
        return (
          <div key={n.id} style={style} className={border}>
            <div className="flex items-center gap-3 py-2 pl-3">
              <div className={`w-2 h-2 rounded-full ${dot}`} />
              <div className="flex-1">
                <div className="text-sm text-white">{n.name} <span className="text-xs text-slate-500 ml-2 capitalize">{n.role}</span></div>
                <div className="text-xs text-slate-500 font-mono">{n.phone} · {n.referral_code} · {n.points_balance} pts</div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
